import { Controller } from "@hotwired/stimulus"
import { tooltips } from "../src/functions"

// Connects to data-controller="errors-on-tabs"
export default class extends Controller {
  connect() {
    const tabs = this.element.querySelectorAll('.nav-pills a')

    tabs.forEach((tab) => {
      const targetId = tab.getAttribute('href')
      const pane = this.element.querySelector(targetId)

      if (!pane) return

      const errorCount = pane.querySelectorAll('.invalid-feedback').length

      if (errorCount > 0) {
        const badge = document.createElement('span')
        badge.className = 'badge rounded-pill bg-danger me-1'
        badge.textContent = errorCount

        const label = errorCount === 1 ? 'erro' : 'erros'
        badge.setAttribute('data-bs-toggle', 'tooltip')
        badge.setAttribute('data-bs-title', `${errorCount} ${label} nesta aba`)

        tab.append(badge)
      }
    })

    tooltips()
  }
}